import './App.css';
import NavBootstrap from './Nav';
import Home from './routes/Home';
import Publications from './routes/Publications';
import Resources from './routes/Resources';
import Acknowledgements from './routes/Acknowledgements.js';
import Members from './routes/Members';
import EatGlass from './routes/EatGlass';
import {BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Footer from './Footer';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
   <HelmetProvider>
     <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
       <div className="App">
       <Helmet>
                  <meta charSet="utf-8" />
                  <title>r410 Research Group</title>
        </Helmet>

      <NavBootstrap />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/members" element={<Members />} />
        <Route path="/publications" element={<Publications />} />
        <Route path='/resources' element={<Resources />} />
        <Route path='/acknowledgements' element={<Acknowledgements />} />
        <Route path='/eatGlass' element={<EatGlass />} />
      </Routes>
      <Footer/>
       </div>
     </Router>
   </HelmetProvider>
  );
}

export default App;
